export default "__VITE_ASSET__C7tRJ601__"